import React from 'react';
import { CheckIcon, MinusIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { afterItems, beforeItems } from '../data/content';
export function BeforeAfter() {
  return <section className="w-full bg-cream px-5 pb-24 sm:pb-32" data-id="element-28" data-mp="3og1bwlmh5s8l">
      <div className="mx-auto w-full max-w-[1120px]" data-id="element-29" data-mp="3ohubxi2l1e7m">
        <div className="grid gap-6 md:grid-cols-2" data-id="element-30" data-mp="3sgl89mz84rto">
          <Reveal data-id="element-31" data-mp="3sj7hdr1rjfe0">
            <div className="h-full overflow-hidden rounded-card border border-red bg-red-tint" data-id="element-32" data-mp="3eq847vpgdx9m">
              <h3 className="bg-red px-6 py-3 font-display text-lg font-bold uppercase tracking-[0.14em] text-white" data-id="element-33" data-mp="3jgeppmoo51nn">
                Før
              </h3>
              <ul className="space-y-4 px-6 py-7 sm:px-8" data-id="element-34" data-mp="34td3r79mdmsp">
                {beforeItems.map(item => <li key={item} className="flex items-start gap-3" data-id="element-35" data-mp="39r4wu4m03eyh">
                    <span className="mt-1 flex h-5 w-5 shrink-0 items-center justify-center rounded-full border border-red/40" data-id="element-36" data-mp="2vs5bp6xp5i72">
                      <MinusIcon className="h-3 w-3 text-red" aria-hidden="true" data-id="element-37" data-mp="30pdvtd2enway" />
                    </span>
                    <span className="text-base leading-relaxed text-ink" data-id="element-38" data-mp="x6n0023qenjz">{item}</span>
                  </li>)}
              </ul>
            </div>
          </Reveal>

          <Reveal delay={0.06} data-id="element-39" data-mp="172817y0z7jso">
            <div className="h-full overflow-hidden rounded-card border border-green bg-green-tint" data-id="element-40" data-mp="123n96lvvo6fb">
              <h3 className="bg-green px-6 py-3 font-display text-lg font-bold uppercase tracking-[0.14em] text-white" data-id="element-41" data-mp="ee2e54mg9ipo">
                Med Håndboldklar
              </h3>
              <ul className="space-y-4 px-6 py-7 sm:px-8" data-id="element-42" data-mp="9gsobnv5f51b">
                {afterItems.map(item => <li key={item} className="flex items-start gap-3" data-id="element-43" data-mp="o5yphhdjr5bu">
                    <span className="mt-1 flex h-5 w-5 shrink-0 items-center justify-center rounded-full border border-green/40" data-id="element-44" data-mp="jcdp5iohdz9h">
                      <CheckIcon className="h-3 w-3 text-green" aria-hidden="true" data-id="element-45" data-mp="3rqw3g250mb1j" />
                    </span>
                    <span className="text-base font-medium leading-relaxed text-ink" data-id="element-46" data-mp="1qqr3m4xl2fx8">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </Reveal>
        </div>
      </div>
    </section>;
}